import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

export type PremiumServicePlan = 'standard' | 'premium';

export interface PremiumServiceCodSheetData {
  currentPlan: PremiumServicePlan;
  onConfirm: (selectedPlan: PremiumServicePlan) => Promise<void>;
}

@Component({
  selector: 'app-premium-service-cod-bottomsheet',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './premium-service-cod-bottomsheet.component.html',
})
export class PremiumServiceCodBottomSheetComponent {
  selectedPlan: PremiumServicePlan;

  constructor(
    private readonly sheetRef: MatBottomSheetRef<PremiumServiceCodBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly data: PremiumServiceCodSheetData,
  ) {
    this.selectedPlan = data.currentPlan;
  }

  close(): void {
    this.sheetRef.dismiss();
  }

  async confirm(): Promise<void> {
    if (this.selectedPlan !== this.data.currentPlan) {
      await this.data.onConfirm(this.selectedPlan);
    }
    this.sheetRef.dismiss({ action: 'continue-cod', plan: this.selectedPlan });
  }
}
